import { Title } from "@vds/typography";
import React, { useEffect, useState } from "react";
import {
  CheckboxField,
  CheckboxListField,
  mergeMissingDefaults,
  resolveDefaultFieldValue,
  ObjectGroup,
  SelectInputField,
  TextInputField,
} from "../../global/components/Modals/AdvancedConfiguration/MainSection";
import { MainSectionWrapper } from "../../global/components/Modals/AdvancedConfiguration/styles";
import { CVAPP_OBJECTBLUR } from "../../global/constants/cvappConstants";

const StandardForm = ({
  data,
  advancedData,
  setAdvancedData,
  parameterKeyName = "deploy-parameters",
  setIsStandardConfigTampered,
  appName,
  ErrorInFormInput,
  setErrorInFormInput,
}) => {
  const [schemaData, setSchemaData] = useState({});
  useEffect(() => {
    const payload = {
      config: {
        [parameterKeyName]: {},
      },
    };
    data?.scemaResourceData?.forEach((item) => {
      const scemaTemplateData = data?.scemaTemplateData[item?.key];
      // NPDIOTS-9546: skip seeding when there's no real default (null/undefined)
      // instead of falling through to "" — invalid for non-string fields
      // (e.g. max_occupancy) and gets sent to the backend unedited, causing a 400.
      const { hasValue, value } = resolveDefaultFieldValue(scemaTemplateData);
      if (hasValue) {
        payload["config"][parameterKeyName][item?.key] = value;
      }
    });
    const existingParams = advancedData?.config?.[parameterKeyName] || {};
    if (Object.keys(existingParams).length === 0) {
      setAdvancedData({ ...payload });
    } else {
      // Edit flow: advancedData can already carry a saved deploy-parameters blob
      // that only contains keys from ANOTHER form section (e.g. advanced-form
      // fields), so it's non-empty but still missing this section's keys. Backfill
      // only what's missing so saved/edited values are never clobbered.
      const merged = mergeMissingDefaults(existingParams, payload.config[parameterKeyName]);
      if (merged) {
        setAdvancedData({
          config: {
            [parameterKeyName]: merged,
          },
        });
      }
    }
    setSchemaData({ ...data });
  }, [data]);

  return (
    <div
      className="vision-roi-box"
      style={{ height: appName === CVAPP_OBJECTBLUR ? "300px" : "150px", overflowY: "auto" }}
    >
      {/* <div style={{ marginTop: "10px" }}>
        <Title size="small" primitive="h2" viewport="desktop">
          Select object(s) that will be detected from this region of interest
        </Title>
      </div> */}
      <div style={{ marginTop: "15px" }}>
        <MainSectionWrapper>
          {schemaData?.scemaResourceData
            ?.filter((d) => schemaData?.scemaTemplateData[d?.key])
            ?.map((item) => {
              const schemaTemplateObject =
                schemaData?.scemaTemplateData[item?.key];
              return (
                <>
                  {(item?.elementType === "search" ||
                    item?.elementType === "text") &&
                    schemaTemplateObject?.showSeparately !== true && (
                      <TextInputField
                        style={{
                          maxWidth: "content-width",
                          minWidth: "45%",
                          boxSizing: "border-box",
                        }}
                        schemaTemplateObject={schemaTemplateObject}
                        title={schemaTemplateObject?.title || item?.key}
                        keyName={item?.key}
                        setPayload={setAdvancedData}
                        payload={advancedData}
                        parameterKeyName={parameterKeyName}
                        setIsTampered={setIsStandardConfigTampered}
                        setErrorInFormInput={setErrorInFormInput}
                        cvAppName={appName}
                      />
                    )}
                  {item?.elementType === "select" &&
                    schemaTemplateObject?.showSeparately !== true && (
                      <SelectInputField
                        style={{
                          maxWidth: "content-width",
                          minWidth: "45%",
                          boxSizing: "border-box",
                        }}
                        title={
                          schemaTemplateObject?.title
                            ? schemaTemplateObject?.title
                            : item?.key === "severity"
                            ? "Severity"
                            : item?.key
                        }
                        schemaTemplateObject={schemaTemplateObject}
                        keyName={item?.key}
                        setPayload={setAdvancedData}
                        payload={advancedData}
                        parameterKeyName={parameterKeyName}
                        setIsTampered={setIsStandardConfigTampered}
                      />
                    )}

                  {item?.elementType === "checkboxes" &&
                    schemaTemplateObject?.type === "array" &&
                    schemaTemplateObject?.showSeparately !== true && (
                      <CheckboxListField
                        style={{ width: "100%" }}
                        schemaTemplateObject={schemaTemplateObject}
                        title={schemaTemplateObject?.title || item?.key}
                        keyName={item?.key}
                        setPayload={setAdvancedData}
                        payload={advancedData}
                        parameterKeyName={parameterKeyName}
                        setIsTampered={setIsStandardConfigTampered}
                        setErrorInFormInput={setErrorInFormInput}
                        cvAppName={appName}
                      />
                    )}
                  {item?.elementType === "checkboxes" &&
                    schemaTemplateObject?.type === "boolean" &&
                    schemaTemplateObject?.showSeparately !== true && (
                      <CheckboxField
                        style={{ width: "100%" }}
                        schemaTemplateObject={schemaTemplateObject}
                        title={
                          schemaTemplateObject["title"] ||
                          schemaTemplateObject["notitle"] ||
                          item?.key
                        }
                        keyName={item?.key}
                        setPayload={setAdvancedData}
                        payload={advancedData}
                        parameterKeyName={parameterKeyName}
                        additionalInfo={item?.additionalInfo}
                        setIsTampered={setIsStandardConfigTampered}
                      />
                    )}

                  {(item?.elementType === "object" ||
                    schemaTemplateObject?.type === "object") &&
                    schemaTemplateObject?.showSeparately !== true && (
                      <ObjectGroup
                        schemaTemplateObject={schemaTemplateObject}
                        cvAppName={appName}
                        keyName={item?.key}
                        parameterKeyName={parameterKeyName}
                        payload={advancedData}
                        setPayload={setAdvancedData}
                        setIsTampered={setIsStandardConfigTampered}
                        setErrorInFormInput={setErrorInFormInput}
                      />
                    )}
                </>
              );
            })}
        </MainSectionWrapper>
      </div>
    </div>
  );
};

export default StandardForm;
